<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <page layout="tabbed">
      <page-header-new :title="title" :breadcrumbs="breadcrumbs">
        <div slot="actions">
          <date-filter @change="setDateProps($event)" />
        </div>
      </page-header-new>
      <page-tabs :tabs="availableTabs" />
    </page>
  </rest-page>
</template>
<script>
import Page from '@/common/components/page/Page'
import RestPage from '@/common/components/rest/RestPage'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import DateFilter from '@/common/components/dashboard/DateFilter'
import {
  getDateFilterRange,
  projectEndpoint,
  projectRoute
} from '@/core/helpers'
import {
  channelLabels,
  platformChannelLabels
} from '@/modules/analytics/enum/ChannelLabels'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import RestApi from '@/core/services/RestApi'
import moment from 'moment'

export default {
  name: 'CampaignChannelAnalyticsPage',
  components: { PageTabs, PageHeaderNew, Page, DateFilter, RestPage },
  data() {
    return {
      breadcrumbs: [],
      dateRange: {
        end: null,
        start: null
      },
      model: {},
      channelLabels,
      platformChannelLabels,
      campaignTypeEnum,
      campaignTitle: '',
      campaignType: '',
      date_from: '',
      date_to: ''
    }
  },
  mounted() {
    RestApi(
      projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}`,
        params: {
          expand: 'type'
        }
      })
    ).then(({ data }) => {
      this.campaignType = data.type
      this.campaignTitle = data.title
      this.breadcrumbs = [
        {
          label: this.$t('Analytics_Breadcrumb_Analytics')
        },
        {
          label: this.$t('Analytics_Breadcrumb_Campaigns'),
          route: projectRoute({ name: 'AnalyticsCampaigns' })
        },
        {
          label: data.title,
          route: projectRoute({
            name: 'CampaignOverview',
            query: { id: data.id }
          })
        },
        {
          label:
            this.$t(channelLabels[this.channel]) ||
            this.$t(platformChannelLabels[this.channel])
        }
      ]
    })
    let dateRange = getDateFilterRange()
    this.setDateProps(dateRange)
  },

  computed: {
    title() {
      return (
        this.campaignTitle +
        ': ' +
        (this.$t(channelLabels[this.channel]) ||
          this.$t(platformChannelLabels[this.channel]))
      )
    },

    campaignId() {
      return this.$route.query.id || null
    },

    channel() {
      return this.$route.query.channel || null
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics`,
        handler: data => {
          this.model = data
        }
      })
    },

    availableTabs() {
      switch (this.channel) {
        case 'email':
          const tabs = [
            this.tabs.statisticsTab,
            this.tabs.clickedLinksTab,
            this.tabs.clickMapTab,
            this.tabs.domainsTab,
            this.tabs.bouncesTab
          ]

          // remove Click Map tab from workflow campaigns
          if (this.campaignType === campaignTypeEnum.TYPE_WORKFLOW) {
            tabs.splice(2, 1)
          }

          return tabs
        case 'sms':
          return [
            this.tabs.statisticsTab,
            this.tabs.clickedLinksTab,
            this.tabs.bouncesTab
          ]
        case 'inbox':
          return [this.tabs.statisticsTab, this.tabs.bouncesTab]
        case 'inapp':
        case 'inapp_ios':
        case 'inapp_android':
        case 'onsite':
        case 'mobile_push':
        case 'mobile_push_ios':
        case 'mobile_push_android':
        case 'web_push':
          return [
            this.tabs.statisticsTab,
            this.tabs.actionsTab,
            this.tabs.bouncesTab
          ]
      }
    },

    queryParams() {
      return {
        id: this.campaignId,
        channel: this.channel,
        date_from: this.formatDate(this.date_from),
        date_to: this.formatDate(this.date_to)
      }
    },

    tabs() {
      return {
        statisticsTab: {
          title: this.$t('CampaignChannelAnalytics_StatisticsTab'),
          route: projectRoute({
            name: 'StatisticsTab',
            query: this.queryParams
          })
        },
        clickedLinksTab: {
          title: this.$t('CampaignChannelAnalytics_ClickedLinksTab'),
          route: projectRoute({
            name: 'ClickedLinks',
            query: this.queryParams
          })
        },
        clickMapTab: {
          title: this.$t('CampaignChannelAnalytics_ClickMapTab'),
          route: projectRoute({
            name: 'ClickMap',
            query: this.queryParams
          })
        },
        domainsTab: {
          title: this.$t('CampaignChannelAnalytics_DomainsTab'),
          route: projectRoute({
            name: 'Domains',
            query: this.queryParams
          })
        },
        bouncesTab: {
          title: this.$t('CampaignChannelAnalytics_BouncesTab'),
          route: projectRoute({
            name: 'Bounces',
            query: this.queryParams
          })
        },
        actionsTab: {
          title: this.$t('CampaignChannelAnalytics_ActionsTab'),
          route: projectRoute({
            name: 'Actions',
            query: this.queryParams
          })
        }
      }
    }
  },

  methods: {
    setDateProps(event) {
      this.date_from = event.start
      this.date_to = event.end
    },

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/analytics/pages/CampaignChannelAnalyticsPage.vue